import { Box } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

import { usePendingApprovalsContext } from "../contexts"
import { useQualityApprovalList } from "../hooks/useQualityApprovalList"

import { QualityApprovalTable } from "./QualityApprovalTable"

import type { QualityApproval } from "@/graphql/codegen/graphql"
import OverrideTestResultsDialog from "@/screens/Products/components/Product/Quality/TestResults/components/OverrideTestResultsDialog/OverrideTestResultsDialog"
import { useGetProductTestDocuments } from "@/screens/Products/components/Product/Quality/TestResults/hooks"

export const QualityApprovalsTabPanel: FC = () => {
  const [reviewingQualityApproval, setReviewingQualityApproval] = useState<QualityApproval | undefined>()
  const { refetchTaskCounts } = usePendingApprovalsContext()

  const {
    qualityApprovals,
    isFetching: isQualityApprovalsFetching,
    error,
    sorting,
    tableContainerRef,
    refetch: refetchQualityApprovals,
    handleScroll,
    handleSortingChange,
  } = useQualityApprovalList()

  const productTest = reviewingQualityApproval?.productTestResult?.productTest
  const { documents, isFetching: isDocumentsFetching } = useGetProductTestDocuments(productTest?.productTestId)

  const handleTestReview = (qualityApproval: QualityApproval) => setReviewingQualityApproval(qualityApproval)

  const handleReviewClose = () => setReviewingQualityApproval(undefined)

  const handleReviewSubmit = () => {
    setReviewingQualityApproval(undefined)
    refetchQualityApprovals()
    refetchTaskCounts()
  }

  return (
    <Box className='flex min-h-0 flex-1 overflow-y-auto' data-testid='dashboard.quality-approvals-tab-panel'>
      <QualityApprovalTable
        data={qualityApprovals}
        loading={isQualityApprovalsFetching}
        error={error}
        sorting={sorting}
        containerRef={tableContainerRef}
        onScroll={handleScroll}
        onSortingChange={handleSortingChange}
        onTestReview={handleTestReview}
      />
      {reviewingQualityApproval?.productTestResult && productTest && !isDocumentsFetching && (
        <OverrideTestResultsDialog
          onClose={handleReviewClose}
          onSubmit={handleReviewSubmit}
          productTestResult={reviewingQualityApproval.productTestResult}
          productTest={{ ...productTest, documents }}
          qualityApprovalId={reviewingQualityApproval.qualityApprovalId}
        />
      )}
    </Box>
  )
}
